import { Injectable } from '@angular/core';
import { io, Socket } from 'socket-io-client-v4';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SocketIoService {
  private socket: Socket;

  constructor(private http: HttpClient) {
    this.socket = io(`${environment.microServiceSocketHost}member`, {
      query: {
        project_code: environment.projectCode,
      },
      withCredentials: true,
      transports: ['websocket']
    });
  }

  // Emit an event to the server
  emitEvent(eventName: string, data?: any): void {
    this.socket.emit(eventName, data);
  }

  // Listen for events from the server
  onEvent(eventName: string): Observable<any> {
    return new Observable(observer => {
      this.socket.on(eventName, (data) => {
        observer.next(data);
      });
    });
  }

  // Disconnect the socket
  disconnect(): void {
    this.socket.disconnect();
  }
}
